<template>
  <div v-if="visible" class="consumption-mode-popup-overlay" @click="closePopup">
    <div class="consumption-mode-popup" @click.stop>
      <!-- 跳窗標題 -->
      <div class="popup-header">
        <h2 class="popup-title">請選擇消費模式</h2>
      </div>
      
      <!-- 消費模式選項列表 -->
      <div class="mode-options">
        <button 
          v-for="(mode, index) in availableModes" 
          :key="index"
          class="mode-option-button"
          @click="selectMode(mode)"
        >
          <span class="mode-option-text text-primary-color">{{ mode.name }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConsumptionModePopup',
  props: {
    // 控制跳窗顯示狀態
    visible: {
      type: Boolean,
      default: false
    },
    // 可用的消費模式列表
    availableModes: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  methods: {
    // 選擇消費模式
    selectMode(mode) {
      // 根據模式名稱決定模式類型
      let modeType = ''
      switch(mode.name) {
        case '門市內用':
          modeType = 'dineIn'
          break
        case '現場外帶':
          modeType = 'takeOut'
          break
        case '預約自取':
          modeType = 'pickUp'
          break
        case '店家外送':
          modeType = 'delivery'
          break
        default:
          modeType = 'dineIn'
      }
      
      // 發送選擇事件
      this.$emit('selectMode', { mode: modeType })
    },
    
    // 關閉跳窗
    closePopup() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
// 跳窗遮罩層
.consumption-mode-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

// 跳窗主體
.consumption-mode-popup {
  background-color: white;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

// 跳窗標題區域
.popup-header {
  padding: 24px 20px 16px;
  text-align: center;
}

.popup-title {
  font-size: 18px;
  font-weight: 600;
  color: #666;
  margin: 0;
  font-family: PingFang SC, sans-serif;
}

// 模式選項區域
.mode-options {
  padding: 20px 16px; // 調整內距
  display: flex;
  flex-direction: column;
  gap: 0; // 移除間距，因為按鈕本身有 margin
}

// 模式選項按鈕
.mode-option-button {
  width: 90%; // 調整寬度，讓按鈕不要滿版
  margin: 8px auto; // 新增：置中並增加上下間距
  padding: 16px 24px; // 調整內距
  border: none;
  background-color: #EEEEEE; // 修改：淺灰色背景
  border-radius: 4px; // 新增：圓角設計
  display: flex;
  justify-content: center; // 修改：文字置中
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:active {
    background-color: #D5D5D5; // 修改：點擊時更深
    transform: translateY(0); // 新增：點擊回彈效果
  }
}

// 模式選項文字
.mode-option-text {
  font-size: 24px;
  font-weight: 600; // 修改：字體加粗
  font-family: PingFang SC, sans-serif;
  text-align: center; // 新增：文字置中
}

// 響應式設計
@media (max-width: 480px) {
  .consumption-mode-popup {
    width: 95%;
    margin: 20px;
  }
  
  .popup-title {
    font-size: 18px;
  }
  
  .mode-option-text {
    font-size: 22px;
    font-weight: 600; // 保持加粗
  }
  
  .mode-option-button {
    padding: 14px 20px; // 小螢幕調整內距
    width: 100%; // 小螢幕稍微調整寬度
  }
}
</style>